module.exports = __webpack_public_path__ + "img/ysup.b165a217.png";